import React from 'react';

const InfoListCard = ({ title, items, type }) => {
  return (
    <div className="list-card">
      <div className="list-header">
        <h3>{title}</h3>
        <button>View All</button>
      </div>

      <div className="list-items">
        {items.map((item, index) => (
          <div className="list-item" key={index}>
            <div>
              <h4>{item.title}</h4>
              <p>{item.subtitle}</p>
            </div>

            <div className="list-right">
              <strong>{item.value}</strong>
              <span className={item.status}>{item.status}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfoListCard;